import axios from "axios";

import * as config from '../config';
import { ApiPost } from "./ApiService";


function parseJwt(token) {
  console.log("Parsing token", token)
  return JSON.parse(atob(token.split('.')[1]));
}

function login(username, password, dispatch, setUser) {
  console.log("Logging in user:", username, config.API_URL + "/dmz-api/login")
  return axios
    .post(config.API_URL + "/dmz-api/login", {
      username,
      password
    })
    .then(response => {
      console.log("Response", response)
      processTokens(response.data);
      dispatch(setUser(response.data));
      return response.data;
    });
}

function processTokens(data) {
  console.log("Processing tokens", data);
  if (!!data.authenticationToken) {
    localStorage.setItem("user", JSON.stringify(data));
    if (!!data.refreshToken) {
      startRefreshTimer();
    } else {
      console.log("refresh token not found!");
    }
  } else {
    console.log("invalid response, access tocken not found!");
    localStorage.removeItem("user");
    window.location.href = "/";
  }
}


function refreshToken() {
  console.log("Refeshing token now");
  clearTimeout();
  var userData = JSON.parse(localStorage.getItem('user'));
  if (!!userData) {
    let refreshToken = userData.refreshToken;
    if (!!refreshToken) {
      ApiPost('/dmz-api/refresh', { refreshToken: refreshToken },
        (data) => {
          console.log("Token refreshed!")
          console.log(data);
          processTokens(data);
        },
        (error) => {
          console.log("Error while refreshing token, logging out", error);
          localStorage.removeItem("user");
          window.location.href = "/";
        });
    } else {
      console.log("Local user storage has no refresh token");
    }
  } else {
    console.log("Invalid user data in local storage");
  }

}

function startRefreshTimer() {
  var dateNow = new Date();
  var userData = JSON.parse(localStorage.getItem('user'));
  if (!!userData) {
    let jwt = parseJwt(userData.authenticationToken);
    let timeToExpire = jwt.exp * 1000 - parseInt(dateNow.getTime()) - 10 * 1000; // refresh 10 seconds before

    if (timeToExpire > 0) {
      setTimeout(refreshToken, timeToExpire);
      console.log("Refresh token timer started, will refresh in ", timeToExpire / 1000 + " sec");
    } else {
      console.log("Token expired already!");
      localStorage.removeItem("user");
      window.location.href = "/";
    }
  } else {
    console.log("No user data in local storage");
  }
}

function logout() {
  localStorage.removeItem("user");
}

function register(username, email, password) {
  return axios.post(config.API_URL + "signup", {
    username,
    email,
    password
  });
}

function checkExpiration(token) {
  var jwt = parseJwt(token);
  var dateNow = new Date();
  var expired = jwt.exp < dateNow.getTime() / 1000;
  console.log("Token expired:", jwt.exp, dateNow.getTime() / 1000, expired);
  return (expired)
}


export { login, logout, register, checkExpiration, startRefreshTimer, parseJwt };
